import { useMemo } from 'react';
import type { IQrCodeProps } from './IQrCodeProps';
import { qrMatrix } from './qr/qrMatrix';

/** Тиха зона навколо коду — 4 модулі (ISO/IEC 18004). */
const QUIET = 4;

/**
 * QR-код як SVG (кодується в браузері, без запитів назовні): темні модулі одним контуром на білому тлі з тихою зоною, чіткі краї. Кольори —
 * атрибутами SVG, не темою: сканер читає чорне на білому й у темній схемі. Задовгий текст — нічого (ключ лишається для ручного введення).
 */
export function QrCode({ text, size, label }: IQrCodeProps) {
  const path = useMemo(() => {
    const m = qrMatrix(text);
    if (!m) return null;
    const d = m.flatMap((row, y) => row.map((dark, x) => (dark ? `M${x + QUIET} ${y + QUIET}h1v1h-1z` : ''))).join('');
    return { d, n: m.length + QUIET * 2 };
  }, [text]);
  if (!path) return null;
  return (
    <svg className="au-qr" width={size} height={size} viewBox={`0 0 ${path.n} ${path.n}`} role="img" aria-label={label} shapeRendering="crispEdges">
      <rect width={path.n} height={path.n} fill="#fff" />
      <path d={path.d} fill="#000" />
    </svg>
  );
}
